/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './signPlcOperation.defs.js'
export * as $defs from './signPlcOperation.defs.js'
